import { useEffect, useState } from "react";
import { adminApi, fmt } from "@/lib/api";

const Card = ({ label, value, testId, color }) => (
  <div className="x-panel p-4">
    <div className="text-[12px] font-semibold text-[var(--x-muted)]">{label}</div>
    <div data-testid={testId} className="text-2xl font-black tabular-nums mt-1" style={{ color }}>{value}</div>
  </div>
);

export const AdminStats = () => {
  const [s, setS] = useState(null);
  const [bets, setBets] = useState([]);
  useEffect(() => {
    adminApi.get("/admin/stats").then((r) => setS(r.data));
    adminApi.get("/admin/bets").then((r) => setBets(r.data));
  }, []);
  if (!s) return null;
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Card label="Kullanıcı" value={s.users} testId="stat-users" />
        <Card label="Toplam Bahis" value={s.bets} testId="stat-total-bets" />
        <Card label="Çevrim" value={`₺${fmt(s.wagered)}`} testId="stat-wagered" />
        <Card label="Kasa Kârı (GGR)" value={`₺${fmt(s.ggr)}`} testId="stat-ggr" color={s.ggr >= 0 ? "#00e701" : "#ed4163"} />
        <Card label="Onaylı Yatırım" value={`₺${fmt(s.deposits)}`} testId="stat-deposits" />
        <Card label="Onaylı Çekim" value={`₺${fmt(s.withdrawals)}`} testId="stat-withdrawals" />
        <Card label="Bekleyen Yatırım" value={s.pending_deposits} testId="stat-pending-deposits" color="#f5a623" />
        <Card label="Bekleyen Çekim" value={s.pending_withdrawals} testId="stat-pending-withdrawals" color="#f5a623" />
      </div>
      <div className="x-panel overflow-x-auto">
        <div className="px-4 pt-4 pb-2 font-extrabold">Son Bahisler</div>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[var(--x-muted)]">
            <th className="px-4 py-2">Kullanıcı</th><th className="px-4 py-2 text-right">Bahis</th><th className="px-4 py-2 text-right">Çarpan</th><th className="px-4 py-2 text-right">Ödeme</th><th className="px-4 py-2">Zaman</th>
          </tr></thead>
          <tbody>
            {bets.map((b) => (
              <tr key={b.id} className="border-t border-white/5">
                <td className="px-4 py-2 font-bold">{b.username}</td>
                <td className="px-4 py-2 text-right">₺{fmt(b.amount)}</td>
                <td className="px-4 py-2 text-right">{fmt(b.multiplier)}×</td>
                <td className={`px-4 py-2 text-right font-bold ${b.win ? "text-[var(--x-green)]" : "text-[var(--x-muted)]"}`}>₺{fmt(b.payout)}</td>
                <td className="px-4 py-2 text-[var(--x-muted)]">{new Date(b.created_at).toLocaleString("tr-TR")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
